import { FC, useCallback } from "react";

import { Button } from "react-migration/components/Button";
import Feature from "src/js/stores/user/Feature";
import { Intercom } from "react-migration/lib/util/intercom";
import { logEvent } from "react-migration/lib/util/logEvent";
import { useBetaFeatureFlag } from "react-migration/lib/user/useFeatureFlag";

export const HelpMenu: FC = () => {
  const toggleSupport = useCallback(() => {
    if (Intercom.visible) {
      Intercom("hide");
    } else {
      Intercom("show");
      logEvent("Open Intercom Widget", {
        from: "nav-bar",
        route: window.location.pathname.match(RegExp(/^\/([^/?]+)/))?.[1],
      });
    }
  }, []);
  const hasProjectsBeta = useBetaFeatureFlag(Feature.projectsNavBeta);
  return (
    <Button
      variant="ghost"
      data-testid="help-button"
      leadIcon="lt-question-line"
      onClick={toggleSupport}
      className={hasProjectsBeta ? "hover:bg-neutral-100!" : ""}
    >
      <span className="hidden xl:block">Help &amp; Support</span>
    </Button>
  );
};
